import axios from "axios";
// import toast from "../utils/toast";

const apiClient = axios.create({
  baseURL: "https://api.myrentmitra.com/api",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json", 
    Accept: "application/json",
  },
});

// Attach token to every request automatically
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Unwrap response.data so every API call gets the payload directly
// Also handle 401 globally (token expired)
apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error.response?.status;
    const isLoginRequest = error.config?.url?.includes("/Auth/login");
    if (status === 401) {
      if (isLoginRequest) {
        // Wrong credentials on login page — just show toast, don't redirect
        console.log("Unauthorized User.", "error");
      } else {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

export default apiClient;
